import { Colors } from 'src/components/theme'
import { WidgetCard } from 'src/v2/components/widget-card'

import { ParcelZoningDetailsContent } from 'src/v2/views/owner-reveal/insights/parcel-insights/zoning/zoning-details/content'

const ParcelZoningDetails = () => {
  return (
    <WidgetCard
      id="zoning-details"
      title="Zoning Details"
      headerBgColor={Colors.primaryGreen700}
      headerTextColor={Colors.textWhite}
      loaderHeight={450}
      sections={[
        {
          content: <ParcelZoningDetailsContent />,
        },
      ]}
    />
  )
}

export default ParcelZoningDetails
